var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5459 0.501953C14.0004 0.501953 13.6368 0.865589 13.6368 1.41104V3.22923H15.455V1.41104C15.455 0.865589 15.0914 0.501953 14.5459 0.501953ZM5.45499 0.501953C4.90953 0.501953 4.5459 0.865589 4.5459 1.41104V3.22923H6.36408V1.41104C6.36408 0.865589 6.00044 0.501953 5.45499 0.501953Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3637 20.5012H3.63645C2.18191 20.5012 0.90918 19.2538 0.90918 17.6225V6.1073C0.90918 4.57195 2.091 3.22852 3.63645 3.22852H16.3637C17.8183 3.22852 19.091 4.47599 19.091 6.1073V17.7184C19.091 19.2538 17.9092 20.5012 16.3637 20.5012Z",
    fill: "#EDDFF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 9.59375C7.52119 9.59375 5.45508 11.6599 5.45508 14.1392C5.45508 16.6185 7.52119 18.6847 10.0005 18.6847C12.4799 18.6847 14.546 16.6185 14.546 14.1392C14.546 11.6599 12.4799 9.59375 10.0005 9.59375ZM11.86 16.102C11.7567 16.2053 11.5501 16.3086 11.4468 16.3086C11.2402 16.3086 11.1369 16.2053 11.0336 16.102L9.69062 14.759C9.58731 14.6557 9.484 14.4491 9.484 14.3458V12.0731C9.484 11.7632 9.79392 11.4533 10.1038 11.4533C10.4138 11.4533 10.7237 11.7632 10.7237 12.0731V14.0359L11.86 15.1723C12.0666 15.4822 12.0666 15.7921 11.86 16.102Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.091 5.95703H0.90918V7.77521H19.091V5.95703Z",
    fill: "#A461D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowup);
export default __webpack_public_path__ + "static/media/followup.546ca5fe30cf0a13a11a77310c244ddd.svg";
export { ForwardRef as ReactComponent };